export function createFromString (time)
{
	const boom = time.split(':');

	return {
		hour: parseInt(boom[0]),
		minute: parseInt(boom[1])
	};
}

export function formatFromObject(time)
{
	return time.hour.toString().padStart(2, '0') + ':' + time.minute.toString().padStart(2, '0');
}